export default __webpack_public_path__ + "static/media/scan_logs_icon.c4e7c874.svg";